import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { dateFormat } from '../../util/DateUtil';


export default function BimestreProfileInfo({ bimestre }) {


    return (
        <Grid container spacing={3}>
            <Grid size={3}>
                <Typography variant="body1" color="textSecondary" gutterBottom>
                    Ano Letivo
                </Typography>
                <Typography variant="body1">
                    {bimestre.anoLetivo}
                </Typography>
            </Grid>
            <Grid size={3}>
                <Typography variant="body1" color="textSecondary" gutterBottom>
                    Série
                </Typography>
                <Typography variant="body1">
                    {bimestre.serie.descricao}
                </Typography>
            </Grid>
            <Grid size={3}>
                <Typography variant="body1" color="textSecondary" gutterBottom>
                    Nº Bimestre
                </Typography>
                <Typography variant="body1">
                    {bimestre.numeroBimestre}
                </Typography>
            </Grid>
            <Grid size={3}>
                <Typography variant="body1" color="textSecondary" gutterBottom>
                    Data Início
                </Typography>
                <Typography variant="body1">
                    {dateFormat(bimestre.dataInicio)}
                </Typography>
            </Grid>
            <Grid size={3}>
                <Typography variant="body1" color="textSecondary" gutterBottom>
                    Data Fim
                </Typography>
                <Typography variant="body1">
                    {dateFormat(bimestre.dataFim)}
                </Typography>
            </Grid>
        </Grid>
    );
}